import React from "react"
import styled from "styled-components"
import { ThemeContext } from "../Theme/ThemeContext"

const Background = () => {
  const { isDarkMode } = React.useContext(ThemeContext)

  return (
    <StyledSvg isDarkMode={isDarkMode} />
  )
}

export default Background

const StyledSvg = styled.div<{isDarkMode: boolean}>`
  position: absolute;
  top: 65px;
  left: 0;
  background-image: url(/background.svg);
  background-color: ${(props) => (props.isDarkMode ? "#1f1f1f" : "white")};
  height: 95%;
  width: 100%;
  background-size: auto 100%;
  background-repeat: no-repeat;
  transform: scaleX(-1);

  @media (max-width: 768px) {
    display: none;
  }
`